import * as React from 'react';

/**
 * @description Orders icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Orders } from '@sravni/design-system-icons'
 *
 * <Orders />
 * ```
 */
const Orders = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Orders", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M16.222 5.974c.982 0 1.778.822 1.778 1.838v8.35c0 1.01-.8 1.838-1.778 1.838H3.778C2.796 18 2 17.177 2 16.162V7.693c0-.764.571-1.72 1.714-1.72h.879m11.63 0h-3.937m3.936 0-3.288-3.245a1 1 0 0 0-1.414.009l-1.234 1.25M4.593 5.974l2.989-3.217a1 1 0 0 1 1.437-.028l1.267 1.258M4.593 5.974h7.693m0 0-2-1.987", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14 11a1 1 0 0 1 1-1h3v3h-3a1 1 0 0 1-1-1v-1Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { Orders };
//# sourceMappingURL=Orders.js.map
